<template>
    <Paper>
        <span class="page-description">批量条码信息解析</span>
        <i class="page-description-question el-icon-question" :data-title="pageDescription"></i>
        <div class="codeAnalysis">
            <el-row>
                <el-col :span="19">
                    <el-row>
                        <el-col :span="10">
                            <div class="item firstHead">
                                <div class="search-product">
                                    <el-select v-model="searchData.entityId"  placeholder="主体">
                                        <el-option
                                            v-for="(val, index) in entityIdList"
                                            :key=index
                                            :label="val.name"
                                            :value="val.code">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </el-col>
                <el-col :span="5">
                    <div class="codeAnalysis-search">
                        <div class="search-margin">
                            <el-button type="primary" :loading="searchLoading" size="mini" @click="searchChange" icon='el-icon-search'>
                                {{$translate('lang.E3202101260004', { defaultText: '查 询' })}}
                            </el-button>
                            <el-button class="sn-search-reset-button" @click="restSearchChange" size="mini">
                                {{$translate('lang.E3202101260009', { defaultText: '重 置' })}}
                            </el-button>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="btnList">
            <mExport
                :url='templateExport.exportUrl'
                :params='templateExport.exportParams'
                :name='templateExport.exportName'
                :exportFlag='templateExport.exportFlag'
                :type='templateExport.type'
                :listData='listData'
                :titleText='templateExport.titleText'>
            </mExport>
            <reportExport #default="{ submit }" reportCode="">
                <el-button size="mini" @click="exportPorductFile(submit)" type="primary">
                    {{$translate('lang.E3202101260036', { defaultText: '导出产品Excel' })}}
                </el-button>
            </reportExport>
            <reportExport #default="{ submit }" reportCode="">
                <el-button size="mini" @click="exportListFile(submit)" type="primary">
                    {{$translate('lang.E3202101260037', { defaultText: '导出条码Excel' })}}
                </el-button>
            </reportExport>
            <div>
                <el-upload
                  class="upload-demo"
                  ref="upload"
                  action=""
                  :file-list="fileList"
                  :auto-upload="false"
                  :on-remove="handleRemove"
                  :on-change="fileChange">
                    <el-button size="mini" type="primary">
                        {{$translate('lang.E3202101260038', { defaultText: '条码上传' })}}
                    </el-button>
                </el-upload>
            </div>
        </div>
        <div class="tableContent">
            <div class="codeAnalysisStyle productTable">
                <p>{{$translate('lang.E3202101260039', { defaultText: '解析结果列表-产品' })}}</p>
                <m-table
                  ref="RegistrationTable"
                  :pageTotal="productPage.pageTotal"
                  :tableData="productListData"
                  :currentPage='productPage.currentPage'
                  @handleCurrentChange='handleCurrentChange'
                  @pageChange="productPageChange"
                  @sizeChange="productSizeChange"
                  :config="productTableConfig">
                </m-table>
            </div>
            <div class="codeAnalysisStyle">
                <p>{{$translate('lang.E3202101260040', { defaultText: '解析结果列表-条码' })}}</p>
                <m-table
                  ref="RegistrationTable"
                  :pageTotal="codePage.pageTotal"
                  :tableData="codeListData"
                  :currentPage='codePage.currentPage'
                  @pageChange="codePageChange"
                  @sizeChange="codeSizeChange"
                  :config="codeTableConfig">
                </m-table>
            </div>
        </div>
    </Paper>
</template>
<script>
import Paper from '@/components/core/paper/Paper';
import mTable from '../../../components/IdentityComponent/Main';
import mExport from '../component/export';
import reportExport from '@/components/lots/reportExportPlugin';
import { codeTableConfig } from './codeTableConfig.js';
import { productTableConfig } from './productTableConfig.js';
import { dictWithUrl } from '../../../components/basicDataDialog/api';
import { searchBatchData, searchPage, searchItemPage } from '../../../api/lcbsManagement.js';
const EXPORT_API = '/api-sn/lbcs/bcDecodeBatch/export'; // 通用导出接口路径
export default {
    name: 'codeAnalysis',
    components: { Paper, mTable, mExport, reportExport },
    data() {
        return {
            searchData: {},
            codeTableConfig,
            productTableConfig,
            listData: [],
            productListData: [],
            codeListData: [],
            fileList: [], // 上传文件列表
            templateFlie: {}, // 上传文件
            batchId: '', // 批次
            itemCode: '', // 选中左侧表格的编码
            searchLoading: false,
            productPage: {
                pageTotal: 0,
                currentPage: 1
            },
            codePage: {
                pageTotal: 0,
                currentPage: 1
            },
            templateExport: {
                exportUrl: '/api-sn/lbcs/bcDecodeBatch/templates/download',
                exportName: this.$translate('lang.E3202101260041', { defaultText: 'LBCS批量条码信息解析模板.xls' }),
                exportParams: {},
                titleText: this.$translate('lang.E3202101260042', { defaultText: '导出模板' }),
                exportFlag: 1,
                type: 'get'
            },
            pageDescription: '',
            entityIdList: []
        };
    },
    methods: {
        initData() {
            this.searchData = {
                entityName: ''
            };
            this.batchId = '';
        },
        restSearchChange() {
            this.initData();
            this.templateFlie = {};
            if (this.$refs.upload) {
                this.$refs.upload.clearFiles();
            };
        },
        handleSearchData() {
            const form = new FormData();
            form.append('file', this.templateFlie.raw);
            form.append('entityId', this.searchData.entityId);
            return form;
        },
        searchChange() {
            this.productTableConfig.page.pageNo = 1;
            this.codeTableConfig.page.pageNo = 1;
            this.productPage.currentPage = 1;
            this.codePage.currentPage = 1;
            this.itemCode = ''; // 每次搜索前清空左侧选中的编码
            this.productTableConfig.table.checked = ''; // 清空单选框
            const params = this.handleSearchData();
            this.getBatchId(params);
        },
        getBatchId(params) {
            if (params.get('entityId') === 'undefined' || params.get('entityId') === '' || this.fileList.length < 1) {
                this.$message.warning(this.$translate('lang.EXC202101260003', { defaultText: '主体、条码上传文件都不能为空！' }));
                this.productListData = [];
                this.codeListData = [];
                return;
            };
            this.searchLoading = true;
            searchBatchData(params).then(res => {
                if (res.code === '0') {
                    this.batchId = res.data; // 获取到批次号再查询
                    this.getProductList();
                    this.getCodeList();
                }
            }).finally(() => {
                this.searchLoading = false;
            });
        },
        getProductList() {
            // 解析结果列表-产品
            const productParams = {
                pageNo: this.productTableConfig.page.pageNo,
                pageSize: this.productTableConfig.page.pageSize,
                batchId: this.batchId
            };
            searchItemPage(productParams).then(res => {
                if (res.code === '0') {
                    this.productListData = res.data.list;
                    this.productPage.pageTotal = res.data.totalCount;
                }
            });
        },
        getCodeList() {
            // 解析结果列表-条码
            const codeParams = {
                pageNo: this.codeTableConfig.page.pageNo,
                pageSize: this.codeTableConfig.page.pageSize,
                batchId: this.batchId
            };
            if (this.itemCode) {
                codeParams.itemCode = this.itemCode;
            }
            searchPage(codeParams).then(res => {
                if (res.code === '0') {
                    this.codeListData = res.data.list;
                    this.codePage.pageTotal = res.data.totalCount;
                }
            });
        },
        fileChange(file, fileList) {
            if (fileList.length > 0) {
                this.fileList = [fileList[fileList.length - 1]];
            }
            const testmsg = file.name.substring(file.name.lastIndexOf('.') + 1);
            if (testmsg !== 'xls') {
                this.$message({
                    message: this.$translate('lang.EXC202101260001', { defaultText: '表格上传类型不正确,请上传xls文件' }),
                    type: 'warning'
                });
                this.$refs.upload.clearFiles();
                this.templateFlie = {};
                this.fileList = [];
            } else {
                this.templateFlie = file;
            }
        },
        handleRemove(file) {
            this.templateFlie = {};
            this.fileList = [];
            this.$refs.upload.clearFiles();
            this.searchData['barcodeBatchNo'] = '';
        },
        productPageChange(pageNo) {
            this.productTableConfig.page.pageNo = pageNo;
            this.productPage.currentPage = pageNo;
            this.getProductList();
        },
        productSizeChange(pageSize) {
            this.productTableConfig.page.pageNo = 1;
            this.productPage.currentPage = 1;
            this.productTableConfig.page.pageSize = pageSize;
            this.getProductList();
        },
        codePageChange(pageNo) {
            this.codeTableConfig.page.pageNo = pageNo;
            this.codePage.currentPage = pageNo;
            this.getCodeList();
        },
        codeSizeChange(pageSize) {
            this.codeTableConfig.page.pageNo = 1;
            this.codePage.currentPage = 1;
            this.codeTableConfig.page.pageSize = pageSize;
            this.getCodeList();
        },
        handleCurrentChange(data) {
            this.itemCode = data.itemCode ? data.itemCode : '';
            this.productTableConfig.table.checked = data.itemCode ? data.itemCode : '';
            this.codeTableConfig.page.pageNo = 1;
            this.codePage.currentPage = 1;
            this.getCodeList();
        },
        exportPorductFile(submit) {
            if (!this.batchId) {
                this.$message.warning(this.$translate('lang.EXC202101260002', { defaultText: '暂无导出数据,请重新设置查询条件' }));
                return;
            }
            const productParams = {
                exportFlag: 'item',
                batchId: this.batchId,
                EXPORT_API
            };
            submit(productParams);
        },
        exportListFile(submit) {
            if (!this.batchId) {
                this.$message.warning(this.$translate('lang.EXC202101260002', { defaultText: '暂无导出数据,请重新设置查询条件' }));
                return;
            }
            const codeParams = {
                exportFlag: 'barcode',
                batchId: this.batchId,
                EXPORT_API
            };
            submit(codeParams);
        },
        async dictData() {
            const option = await dictWithUrl('BILL_DESC,BCPARSING_ENTITY_ID');// BILL_DESC-菜单描述
            const dictOptions = {};
            if (+option.code === 0) {
                const dictList = option.data.BILL_DESC;
                this.entityIdList = option.data.BCPARSING_ENTITY_ID;
                dictList.forEach(item => {
                    dictOptions[item.code] = item.name;
                });
            }
            this.pageDescription = dictOptions[this.$options.name].replace(/ {2}/g, '\n');
        }
    },
    async created() {
        await this.dictData();
    },
    mounted() {
        this.initData();
    }
};
</script>
<style lang="less" src='./index.less'>
</style>